import { call, put, takeEvery } from "redux-saga/effects";
import {
  hideCampaignFormatsListLoader,
  setCampaignFormatProfile,
  setCampaignFormatsList,
  setErrorCampaignFormatProfile,
  showCampaignFormatsListLoader
} from "./actions";
import {
  ADD_CAMPAIGN_FORMAT,
  DELETE_CAMPAIGN_FORMAT,
  GET_CAMPAIGN_FORMAT_PROFILE,
  GET_CAMPAIGN_FORMATS_LIST,
  UPDATE_CAMPAIGN_FORMAT_PROFILE
} from "./actionTypes";
import {
  deleteCampaignFormat,
  getCampaignFormatProfile,
  getCampaignFormatsList,
  postCampaignFormat,
  putCampaignFormatProfile
} from "../../../helpers/jwt_helper";
import { getErrorMessage, showErrorMessage, showSuccessMessage } from "../../../helpers/utils";

// Chat Redux States
function* onGetCampaignFormatsList({ payload: data }) {
  try {
    yield put(showCampaignFormatsListLoader());
    // console.log(data);
    let response = yield call(getCampaignFormatsList, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    });
    //console.log(response);
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({ ...i, description: i.description === "string" ? "" : i.description }))
    };
    yield put(setCampaignFormatsList(response));
    yield put(hideCampaignFormatsListLoader());
  } catch (error) {
    yield put(hideCampaignFormatsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddCampaignFormat({ payload: {format, data } }) {
  try {
    yield put(showCampaignFormatsListLoader());
    yield call(postCampaignFormat, {
      name: format.name,
      description: format.description
    });
    yield call(onGetCampaignFormatsList, { payload: data });
    yield put(hideCampaignFormatsListLoader());
    showSuccessMessage("Campaign's format has been added");
  } catch (error) {
    yield put(hideCampaignFormatsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteCampaignFormat({ payload: { id, data } }) {
  try {
    yield put(showCampaignFormatsListLoader());
    yield call(deleteCampaignFormat, id);
    yield call(onGetCampaignFormatsList, { payload: data });
    yield put(hideCampaignFormatsListLoader());
    showSuccessMessage("Campaign format has been deleted");
  } catch (error) {
    yield put(hideCampaignFormatsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCampaignFormatProfile({ payload: id }) {
  try {
    yield put(setErrorCampaignFormatProfile(false));
    let response = yield call(getCampaignFormatProfile, id);
    yield put(setCampaignFormatProfile(response));
  } catch (error) {
    if (getErrorMessage(error) === 'Not found.') {
      yield put(setErrorCampaignFormatProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
  }
}

function* onUpdateCampaignFormatProfile({ payload: {id, format, data } }) {
  try {
    yield put(showCampaignFormatsListLoader());
    yield call(putCampaignFormatProfile, id, {
      name: format.name,
      description: format.description
    });
    yield call(onGetCampaignFormatsList, { payload: data });
    yield put(hideCampaignFormatsListLoader());
    showSuccessMessage("Campaign format has been updated");
  } catch (error) {
    yield put(hideCampaignFormatsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* campaignFormatListSaga() {
  yield takeEvery(GET_CAMPAIGN_FORMATS_LIST, onGetCampaignFormatsList);
  yield takeEvery(DELETE_CAMPAIGN_FORMAT, onDeleteCampaignFormat);
  yield takeEvery(ADD_CAMPAIGN_FORMAT, onAddCampaignFormat);
  yield takeEvery(GET_CAMPAIGN_FORMAT_PROFILE, onGetCampaignFormatProfile);
  yield takeEvery(UPDATE_CAMPAIGN_FORMAT_PROFILE, onUpdateCampaignFormatProfile);
}

export default campaignFormatListSaga;
